import React, { Component } from 'react'
import { Spinner } from "scorpion-core";
import ContainerCrud from "../../../../../components/ContainerCrud";
import { temPermissao } from "../../../../../modules/permissoes/functions";
import DinamicCrudCustomPesquisa from "../DinamicCrudCustomPesquisa";

import { RenderCustomForm, gerarRelatorioEspelho } from "scorpion-core";

import View from 'react-flexbox'

export default class DinamicCrudCustomForm extends Component {
    constructor(props) {
        super(props);
        this.salvar = this.salvar.bind(this);
        this.imprimir = this.imprimir.bind(this);
        this.verificaPermissao = this.verificaPermissao.bind(this);

    }
    salvar(props, retorno) {
        const { customForm } = this.props;
        this.props.salvar(customForm, props, retorno)
    }

    imprimir(salvou) {
        const { customForm } = this.props;
        if (customForm.DebugValues) {
            delete customForm.DebugValues
        }
        gerarRelatorioEspelho(customForm, salvou.item)
    }

    verificaPermissao(permissao) {
        return temPermissao(this.props.customForm.permissao + "." + permissao);
    }
    render() {
        const { customForm } = this.props;
        let comps = [];
        let pesquisa = null;
        let titulo = "Titulo";

        if (customForm && customForm.componenteRoot) {
            comps = customForm.componenteRoot.componentes.slice();
            titulo = customForm.nomeForm
            pesquisa = <DinamicCrudCustomPesquisa componentes={comps} customFormUid={customForm.uid} titulo={"Pesquisa de " + customForm.nomeForm} global={customForm.global} />
        }
        return (<View>
            {customForm && customForm.componenteRoot ? (
                <ContainerCrud propsForm={{ titulo: titulo }} {...this.props}
                    salvar={this.salvar}
                    imprimir={this.imprimir}
                    permiteNovo={true}
                    pesquisa={pesquisa}>
                    <RenderCustomForm componenteRoot={customForm.componenteRoot} propsview={{ ...this.props, verificaPermissao: this.verificaPermissao, customFormUid: customForm.uid }} />
                </ContainerCrud>
            ) : <Spinner />}
        </View>


        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomForm/DinamicCrudCustomForm.js